import { useState } from 'react';
import { Box, Button, useMediaQuery } from '@mui/material';
import { useAccount } from '../../contexts/Account';
import {
  updateCompanyOnBoarding,
  updateCompanyOnboardingStatusCall,
} from '../../services/company_services';
import LoadingLogoSkeleton from '../../components/SkeletonLoading/loadingLogoSkeleton';
import ACSnackbar from '../../components/ACSnackbar';
import { OnboardingStatus, SnackbarType } from '../../services/utils/types';

function step4() {
  const {
    asLoggedUserDetails,
    currentPlan,
    accountDetails,
    editAccountInformation,
    currentUserInfo,
  } = useAccount();
  const [isLoading, setIsLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  const handleClick = async () => {
    try {
      setIsLoading(true);
      await updateCompanyOnBoarding({
        CONTACT_ID: asLoggedUserDetails.userId,
        ON_BOARDING_STATE: true,
        PHONE_COUNTRY_CODE: 'US',
      });
      await updateCompanyOnboardingStatusCall({
        COMPANY_ID: accountDetails.id,
        ONBOARDING_STATUS: 'Complete',
        IS_AOBF: true,
      });
      const contacts = accountDetails?.contacts || [];
      const userData =
        currentUserInfo && currentUserInfo.username
          ? contacts.find((contact) => contact.id === currentUserInfo.username)
          : {};
      const updatedContacts = contacts.map((contact) =>
        contact.id === userData?.id
          ? { ...contact, onboardingProcess: OnboardingStatus.COMPLETE }
          : contact
      );
      editAccountInformation({
        aobfStatus: OnboardingStatus.COMPLETE,
        contacts: updatedContacts,
      });
      window.location.replace(currentPlan.onboardingRedirectUrl);
    } catch (error) {
      setShowSnackbar(true);
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px',
      }}
    >
      <iframe
        src="/static/loading-4-items.html"
        title="Loading Profile"
        frameBorder="0"
        style={{
          width: isXS ? '108%' : '100%',
          height: '400px',
          overflowX: 'visible',
          marginBottom: '40px',
        }}
      />
      <Button
        id="company-onboarding-step-5"
        type="button"
        variant="contained"
        color="primary"
        onClick={handleClick}
        disabled={isLoading}
        sx={{
          borderRadius: '50px',
          height: '48px',
          textTransform: 'none',
          fontSize: '16px',
          fontWeight: 700,
          width: { xxs: '100%', xs: '340px' },
        }}
      >
        {isLoading ? (
          <LoadingLogoSkeleton />
        ) : (
          'Enter Boardroom & Invite People'
        )}
      </Button>

      <ACSnackbar
        open={showSnackbar}
        text="Something went wrong"
        severity={SnackbarType.ERROR}
        onClose={() => {
          setShowSnackbar(false);
        }}
        autoHideDuration={5000}
      />
    </Box>
  );
}

export default step4;
